import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Solapurbusrentalservice() {



  const cardData =
  {
    keyword: 'Solapur Bus Rental Service',
    heading: 'Sanavi Travels: Solapur Bus Rental Service',
    headingDescription: 'Sanavi Travels offers reliable Solapur Bus Rental Service, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, weddings, and outstation travel to and from Solapur. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures smooth rides, ample seating, and sufficient luggage space for hassle-free journeys. With professional drivers, flexible one-way and round-trip bus rental packages, transparent pricing, and 24/7 booking support, Solapur bus rental services are perfect for local travel, sightseeing tours, corporate events, and long-distance trips. Choose Sanavi Travels for trusted bus rental services in Solapur, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Solapur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Solapur City",
    "description": "Solapur is a historic city in Maharashtra, known for its rich textile industry, vibrant culture, and religious significance. The city is a blend of Maratha, Deccan, and Varkari traditions, offering a mix of historical sites, bustling markets, and spiritual destinations. Solapur is famous for its Chaddars, Solapuri Phetas, and traditional cuisine, making it an interesting destination for both culture enthusiasts and travelers."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "The Siddheshwar Temple is Solapur’s most revered shrine, dedicated to Lord Siddheshwar, an incarnation of Lord Shiva. The temple complex includes a pond, a large courtyard, and smaller shrines. The annual fair attracts thousands of devotees, offering a vibrant display of devotion, rituals, and local traditions."
  },
  {
    "title": "Solapur Fort",
    "description": "Solapur Fort is a historic structure built during the Adil Shahi and later Maratha periods. It features massive stone walls, bastions, and gates that reflect medieval military architecture. The fort area offers a glimpse into the city’s historical significance and strategic importance in the Deccan region."
  },
  {
    "title": "Akkalkot Swami Samarth Temple",
    "description": "Located near Solapur, the Akkalkot Swami Samarth Temple is dedicated to the 19th-century saint Swami Samarth Maharaj. Pilgrims visit in large numbers seeking blessings, spiritual guidance, and fulfillment of wishes. The temple complex includes meditation halls, ashrams, and facilities for devotees."
  },
  {
    "title": "Great Indian Bustard Sanctuary (near Solapur)",
    "description": "The Great Indian Bustard Sanctuary is a wildlife conservation area near Solapur, dedicated to protecting the endangered Great Indian Bustard. Nature enthusiasts and wildlife photographers visit to observe rare species, migratory birds, and unique grassland ecosystems in the region."
  },
  {
    "title": "Bhuikot Fort and Heritage Sites",
    "description": "Apart from Solapur Fort, the city has smaller historical forts and heritage sites showcasing Maratha, Adil Shahi, and Nizam architectural influences. These sites provide insight into Solapur’s past and offer opportunities for photography and historical exploration."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "Solapur is famous for its textile markets, Chaddar weaving, and Solapuri Pheta turbans. Local bazaars offer traditional crafts, clothing, and regional delicacies, giving visitors a vibrant shopping experience and a glimpse into local livelihoods."
  },
  {
    "title": "Siddheshwar Lake and Gardens",
    "description": "The temple vicinity includes Siddheshwar Lake and landscaped gardens, providing a peaceful environment for morning walks, meditation, and relaxation. The combination of greenery, water, and spiritual ambiance makes it a serene spot within the bustling city."
  },
  {
    "title": "Religious and Cultural Festivals",
    "description": "Solapur hosts several religious and cultural festivals such as Maha Shivratri, Ganesh Chaturthi, and the Siddheshwar Jatra. These events feature processions, devotional music, folk dances, and community feasts, offering visitors an immersive cultural experience."
  },
  {
    "title": "Solapur’s Rural Surroundings",
    "description": "The areas around Solapur are primarily agricultural, with sugarcane, jowar, and pulses cultivated extensively. Visiting nearby villages allows travelers to experience rural life, traditional farming practices, and local hospitality, adding a serene escape to the city’s urban vibe."
  }
]
,



"services": [
{
"name": "Solapur Bus Rental Service",
"description": "Solapur Bus Rental Service offers reliable and comfortable bus services for local travel, religious tours, corporate trips, and group outings. With well-maintained buses, professional drivers, and timely service, it ensures a safe and convenient journey for families, tourists, and corporate clients, making travel in and around Solapur stress-free and enjoyable."
},
{
"name": "Bus Hire Solapur",
"description": "Bus Hire Solapur provides flexible and affordable bus rental options for all types of travel needs, including weddings, corporate events, and group tours. Equipped with spacious seating, modern amenities, and professional drivers, it guarantees comfort, safety, and a hassle-free experience for travelers in and around Solapur."
},
{
"name": "AC Bus Solapur",
"description": "AC Bus Solapur offers air-conditioned buses for long-distance travel, religious tours, and family outings. These buses ensure a comfortable and refreshing journey with climate control, spacious seating, and professional drivers, making them ideal for group travel and intercity transportation in Solapur."
},
{
"name": "Luxury Bus Solapur",
"description": "Luxury Bus Solapur provides premium buses with modern amenities, plush seating, and excellent onboard facilities. Perfect for corporate clients, weddings, and VIP tours, these buses offer a high-end travel experience, ensuring safety, comfort, and convenience for passengers traveling within Solapur or to nearby destinations."
},
{
"name": "Wedding Bus Solapur",
"description": "Wedding Bus Solapur specializes in providing elegant and comfortable buses for wedding parties and guests. With spacious seating, professional drivers, and timely service, it ensures smooth and stylish transportation for all wedding events, making special occasions even more memorable."
},
{
"name": "Corporate Bus Solapur",
"description": "Corporate Bus Solapur caters to businesses and organizations needing reliable transportation for meetings, conferences, and employee commutes. With professional drivers, comfortable seating, and flexible scheduling, it ensures punctual and stress-free travel for corporate clients."
},
{
"name": "Outstation Bus Solapur",
"description": "Outstation Bus Solapur provides safe and comfortable long-distance bus services to nearby cities and tourist destinations. With well-maintained buses, experienced drivers, and organized itineraries, it ensures a smooth and enjoyable journey for families, groups, and pilgrims traveling from Solapur."
},
{
"name": "Affordable Bus Solapur",
"description": "Affordable Bus Solapur offers budget-friendly rental options without compromising on comfort or safety. Ideal for families, small groups, and long-distance travelers, it provides well-maintained buses, professional drivers, and reliable service for a cost-effective travel experience in and around Solapur."
},
{
"name": "Chauffeur Driven Bus Solapur",
"description": "Chauffeur Driven Bus Solapur ensures a stress-free travel experience with professional drivers handling navigation, traffic, and schedules. Perfect for weddings, corporate trips, and group tours, these buses provide a safe, comfortable, and hassle-free journey for all passengers."
},
{
"name": "Best Bus Service Solapur",
"description": "Best Bus Service Solapur guarantees high-quality buses, punctual service, and experienced drivers for a smooth and reliable travel experience. Suitable for religious trips, corporate events, family outings, and long-distance travel, it combines comfort, safety, and professionalism to meet all transportation needs."
},
{
"name": "Tourist Bus Solapur",
"description": "Tourist Bus Solapur caters to travelers exploring Solapur and nearby attractions. With comfortable seating, experienced drivers, and organized itineraries, it provides a memorable travel experience for families, friends, and groups visiting tourist spots, temples, and heritage sites."
},
{
"name": "Group Travel Bus Solapur",
"description": "Group Travel Bus Solapur offers organized transportation for social clubs, friends, families, and corporate groups. With spacious buses, professional drivers, and well-planned itineraries, it ensures a safe, comfortable, and enjoyable group travel experience in and around Solapur."
},
{
"name": "Online Bus Booking Solapur",
"description": "Online Bus Booking Solapur allows travelers to reserve buses quickly and conveniently through an online platform. With instant confirmation, multiple vehicle options, and flexible scheduling, it simplifies travel planning for families, groups, and corporate clients looking for reliable bus services."
},
{
"name": "Event Bus Solapur",
"description": "Event Bus Solapur specializes in providing buses for special occasions such as weddings, corporate events, parties, and cultural programs. With comfortable seating, professional drivers, and timely service, it ensures smooth transportation for all event attendees, making every occasion hassle-free and memorable."
},
{
"name": "Solapur Travel Bus",
"description": "Solapur Travel Bus provides comprehensive travel solutions for all types of trips, including local sightseeing, religious tours, outstation travel, and group journeys. With reliable vehicles, experienced drivers, and excellent service, it ensures safe, comfortable, and enjoyable travel experiences for all passengers in and around Solapur."
}
],
"tableData": [
["Solapur Bus Rental Service", "Bus Hire Solapur"],
["AC Bus Solapur", "Luxury Bus Solapur"],
["Wedding Bus Solapur", "Corporate Bus Solapur"],
["Outstation Bus Solapur", "Affordable Bus Solapur"],
["Chauffeur Driven Bus Solapur", "Best Bus Service Solapur"],
["Tourist Bus Solapur", "Group Travel Bus Solapur"],
["Online Bus Booking Solapur", "Event Bus Solapur"],
["Solapur Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Solapur Bus Rental Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Solapur, perfect for group outings, family trips, school tours, corporate travel, and pilgrimages."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Solapur and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Solapur routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Solapur, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Solapur bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rental services in Solapur."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Solapur?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Solapur for various travel needs.'
  },
  {
    question: 'How can I book a bus in Solapur?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Solapur?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Solapur?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Solapur routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Solapur?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Solapur and nearby areas.'
  },
  {
    question: 'Is the bus rental service in Solapur available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Solapur to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Solapur.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Patil',
    feedback: 'Booked a bus rental service in Solapur with Sanavi Travels — comfortable journey and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Shinde',
    feedback: 'Sanavi Travels provided a reliable and clean bus for our Solapur trip. Highly recommended!',
    rating: 5
  }
];
































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Solapur Bus Rental Service - Sanavi Travels",
  "description": "Sanavi Travels provides bus rental services in Solapur, including AC and luxury buses for weddings, corporate trips, outstation tours, and group travel. Chauffeur-driven and affordable buses with online booking options.",
  "touristType": "Group Travel, Corporate Travel, Wedding, Outstation",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "32"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Solapur Bus Rental Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Solapur bus rental service with Sanavi Travels. AC, luxury, and affordable chauffeur-driven buses for weddings, corporate trips, tourist tours, and group travel. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/182.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Solapurbusrentalservice;